import { render } from "./CxLogin.vue?vue&type=template&id=4c8e84b1&ts=true"
import script from "./CxLogin.vue?vue&type=script&lang=ts"
export * from "./CxLogin.vue?vue&type=script&lang=ts"

import "./CxLogin.vue?vue&type=style&index=0&id=4c8e84b1&lang=less"

import exportComponent from "/home/ec2-user/workspace/_ui_production_production-1.59.1/microfrontends/conx-ui-login/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__